'use client'

/* eslint-disable react/function-component-definition */
import { useEffect } from 'react'
import { CallbackPopupWrapper, CallbackPopupContentWrapper } from './styles'
import CallbackWidgetForm from './CallbackWidgetForm'

export default function CallbackPopup({ closePopup }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  const handleOverlayClick = e => {
    if ((e.target as HTMLElement).getAttribute('data-value') === 'popup-wrapper') {
      closePopup()
    }
  }

  return (
    <CallbackPopupWrapper data-value="popup-wrapper" onClick={handleOverlayClick}>
      <CallbackPopupContentWrapper data-testid="callback-popup-content-wrapper">
        <CallbackWidgetForm />
      </CallbackPopupContentWrapper>
    </CallbackPopupWrapper>
  )
}
